import { Modal } from "antd";
import Styles from "../css/payWithQuickbucks.module.scss";
import Cancel from "../../../../assets/cancel.svg";
import Caution from "../../../../assets/cautionfailedicon.svg";
const PayWithQuickbucksModalFailed = (props: any) => {
  return (
    <div>
      <Modal
        title="Basic Modal"
        destroyOnClose={true}
        width={500}
        centered
        open={props.isModalOpen}
        onOk={props.handleOk}
        // onCancel={props.handleCancel}
        className={Styles.customModal}
      >
        <div className={Styles.cancelDiv}>
          <img
            onClick={props.goToHistory}
            src={Cancel}
            className={Styles.cancelIcon}
            alt="horse"
            style={{ padding: "2rem" }}
          />
        </div>
        <div className={Styles.modalContentVerification}>
          <div className={Styles.cautionDiv} style={{ marginTop: "0rem" }}>
            <img
              onClick={props.handleCancel}
              src={Caution}
              className={Styles.cautionIcon}
              alt="horse"
            />
          </div>
          <div style={{ textAlign: "center" }} className={Styles.title}>
            Loan request failed
          </div>
          <div style={{ textAlign: "center" }} className={Styles.descThree}>
            Your loan request failed. Please try again
          </div>
          <button onClick={props.goToHistory} className={Styles.btn}>
            TRY AGAIN
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default PayWithQuickbucksModalFailed;
